import React, { useState } from "react";

const FilterCourse = ({ categories, onFilterChange }) => {
  const [active, setActive] = useState("ALL");

  const handleFilterChange = (category) => {
    setActive(category);
    onFilterChange(category);
  };

  return (
    <div
      className="overflow-x-auto w-100 mb-24 text-center px-10"
      data-aos="fade-up"
      data-aos-delay="600"
    >
      <div className="course-fillter px-6 py-14 d-inline-flex justify-content-start justify-content-lg-center gap-2">
        <button
          style={{ whiteSpace: "nowrap" }}
          className={`btn ${
            active === "ALL" ? "btn-primary" : "btn-primary-revert"
          }`}
          onClick={() => handleFilterChange("ALL")}
        >
          ALL
        </button>
        {categories.map((category) => (
          <button
            style={{ whiteSpace: "nowrap" }}
            key={category}
            className={`btn ${
              active === category ? "btn-primary" : "btn-primary-revert"
            }`}
            onClick={() => handleFilterChange(category)}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterCourse;
